import React from 'react';
import { Box, Grid, IconButton, useTheme } from '@mui/material';
import { tokens } from '../../theme';
import Logout from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../utility/auth';
import LogoutController from '../../controller/LogoutController';
import ExceptionHandlerController from '../../controller/ErrorLogsController';

const Topbar = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const tenantName = sessionStorage?.getItem('TenantName');
  const lastLogin = sessionStorage?.getItem('LastLogin');
  const logoutController = new LogoutController();
  const exceptionHandlerController = new ExceptionHandlerController();
  const handleClose = () => {
    let caughtError;
    try {
      let logoutData = {};
      logoutData.User = sessionStorage.getItem('user');
      logoutController
        .Logout(logoutData)
        .then((response) => {
          clearSessionValues(setAnchorEl, auth, navigate);
          sessionStorage.clear();
        })
        .catch((error) => clearSessionValues(setAnchorEl, auth, navigate));
    } catch (error) {
      clearSessionValues(setAnchorEl, auth, navigate);
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: 'Logout method' };
      exceptionHandlerController.HandleException(logError);
    }
  };

  return (
    <Box
      sx={{
        '& .topBar.MuiBox-root': {
          background: `${colors.primary[400]}`,
          borderBottom: `1px solid ${colors.grey[900]}`,
          minHeight: '46px',
          padding: '10px 15px',
        },
        '& .topBar.MuiBox-root .MuiBox-root': { margin: '0 0 0 auto' },
      }}
    >
      <Box display="flex" justifyContent="space-between" className="topBar" p={2}>
        <Grid>
          <>
            {tenantName && lastLogin && (
              <>
                <div>
                  <h2 className="f-20" style={{ margin: '0' }}>
                    {'Welcome ' + tenantName + '  '}
                  </h2>
                </div>
                <div>{' ( Last Login: ' + lastLogin + ' )'}</div>
              </>
            )}
          </>
        </Grid>
        <Box display="flex">
          <IconButton
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClose}
          >
            <Logout />
            <span className="f-14">&nbsp; Logout</span>
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default Topbar;

function clearSessionValues(setAnchorEl, auth, navigate) {
  setAnchorEl(null);
  auth.logout();
  navigate('login');
  sessionStorage.clear();
}
